import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { generateWowCertificate } from '../../wow-challenge/js/generateWowCertificate';

export const PrintExperienceBlock = ({experiences, editAction, field, title, questions}) => {
    const listAllExperience = experiences.map((experience, ei) => {
        const { expOrg, expTitle, startDate, endDate, expPresent, expResponsibilities } = experience;

        const handleEditItem = () => {
            // editAction(ei)
            editAction({
                type: 'update',
                index: ei,
                field, 
                title,
                questions
            });
        }

        return (
            <li className="cv-builder__list-item" key={ei} tabIndex="0">
                <div className="cv-builder__item-container">
                    <h3 className="cv-builder__item-title">{expOrg}</h3>
                    {expTitle ? <p className="cv-builder__item-subtitle">{expTitle}</p> : null}
                    <p className="cv-builder__item-date">{format(parseISO(startDate), 'MMM yyyy')}{expPresent && expPresent.includes('Yes') ? ' - Present' : endDate ? ' - ' + format(parseISO(endDate), 'MMM yyyy') : ''}</p>
                    <PrintListItems listItems={expResponsibilities} />
                </div>

                <button 
                    className="cv-builder__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit experience</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    });

    return (
        <div className="cv-builder__list-block">
            <ul className="cv-builder__list">
                {listAllExperience}
            </ul>
        </div>
    )
}

export const PrintAchievementBlock = ({achievements, editAction, field, title, questions, wowData}) => {
    const listAllAchievements = achievements.map((achievement, ei) => {
        const { achieveTitle, achieveDescription, achieveFile } = achievement;

        const handleEditItem = () => {
            // editAction(ei)
            editAction({
                type: 'update',
                index: ei,
                field, 
                title,
                questions
            });
        }

        const handleClick = (e) => {
            const fileId = achieveFile[0];
            if(fileId === 'wow') {
                e.preventDefault();
                generateWowCertificate(
                    wowData[0], 
                    wowData[1],
                    achieveFile[2],
                    e.target
                )
            }
        }

        return (
            <li className="cv-builder__list-item" key={ei} tabIndex="0">
                <div className="cv-builder__item-container">
                    <h3 className="cv-builder__item-title">{achieveTitle}</h3>
                    <p className="cv-builder__item-subtitle">{achieveDescription}</p>
                    {achieveFile ? (
                        <p className="cv-builder__item-file-pretext">
                            Attached document: 
                            <a 
                                className="cv-builder__item-file"
                                href={achieveFile[2]}
                                onClick={handleClick}
                                >
                                {achieveFile[1]}
                            </a>
                        </p>
                        ) : null}
                </div>

                <button 
                    className="cv-builder__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit {achieveTitle}</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    });

    return (
        <div className="cv-builder__list-block">
            <ul className="cv-builder__list">
                {listAllAchievements}
            </ul>
        </div>
    )
}

export const PrintEducationBlock = ({education, editAction, field, title, questions}) => {
    const listAllExperience = education.map((education, ei) => {
        const { acaTitle, acaInstitution, startDate, endDate, acaPresent } = education;

        const handleEditItem = () => {
            // editAction(ei)
            editAction({
                type: 'update',
                index: ei,
                field, 
                title,
                questions
            });
        }

        return (
            <li className="achievement-list__item" key={ei} tabIndex="0">
                <div className="cv-builder__item-container">
                    <h3 className="cv-builder__item-title">{acaTitle}</h3>
                    <p className="cv-builder__item-subtitle">{acaInstitution}</p>
                    <p className="cv-builder__item-date">{format(parseISO(startDate), 'MMM yyyy')}{acaPresent && acaPresent.includes('Yes') ? ' - Present' : endDate ? ' - ' + format(parseISO(endDate), 'MMM yyyy') : '' }</p>
                </div>

                <button 
                    className="cv-builder__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit {acaTitle}</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    });

    return (
        <div className="cv-builder__list-block">
            <ul className="cv-builder__list">
                {listAllExperience}
            </ul>
        </div>
    )
}

export const PrintTags = ({tagsList}) => {
    const tags = tagsList.map((tag, ti) => {
        return (
            <li className="tags-list__tag" key={ti}>
                {tag}
            </li>
        )
    });

    return (
        <ul className="tags-list__listing">
            {tags}
        </ul>
    )
}


export const PrintListItems = ({listItems}) => {
    const tags = listItems && listItems.map((tag, ti) => {
        return (
            <li className="unordered-list__item" key={ti}>
                {tag}
            </li>
        )
    });

    return (
        <ul className="unordered-list__listing">
            {tags}
        </ul>
    )
}

export const PrintRefereesBlock = ({referees, editAction, field, title, questions}) => {
    const printReferees = referees.map((ref, ri) => {
        const { supTitle, supInfo } = ref;

        const handleEditItem = () => {
            // editAction(ei)
            editAction({
                type: 'update',
                index: ri,
                field, 
                title,
                questions
            });
        }

        return (
            <li className="cv-builder__list-item" key={ri}>
                <div className="cv-builder__item-container">
                    <h3 className="cv-builder__item-title">{supTitle}</h3>
                    {supInfo ? <p className="cv-builder__item-subtitle">{supInfo}</p> : null}
                </div>
                
                <button 
                    className="cv-builder__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit supplement</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    })

    return (
        <div className="cv-builder__list-block">
            <ul className="cv-builder__list">
                {printReferees}
            </ul>
        </div>
    )
}

export const PrintPortfolioBlock = ({portfolio, editAction, field, title, questions}) => {
    const printReferees = portfolio.map((ref, ri) => {
        const { supTitle, supInfo, supFile } = ref;

        const handleEditItem = () => {
            // editAction(ei)
            editAction({
                type: 'update',
                index: ri,
                field, 
                title,
                questions
            });
        }

        return (
            <li className="cv-builder__list-item" key={ri}>
                <div className="cv-builder__item-container">
                    <h3 className="cv-builder__item-title">
                        <a href={supTitle || supFile[2]}
                            title={supInfo ? supInfo : supTitle}>
                            {supInfo ? supInfo : supTitle}
                        </a>
                    </h3>
                </div>
                
                <button 
                    className="cv-builder__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit supplement</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    })

    return (
        <div className="cv-builder__list-block">
            <ul className="cv-builder__list">
                {printReferees}
            </ul>
        </div>
    )
}

PrintAchievementBlock.propTypes = {
    achievements: PropTypes.array, 
    editAction: PropTypes.func,
    field: PropTypes.string,
    title: PropTypes.string,
    questions: PropTypes.array,
    wowData: PropTypes.array
}

PrintExperienceBlock.propTypes = {
    experiences: PropTypes.array, 
    editAction: PropTypes.func,
    field: PropTypes.string,
    title: PropTypes.string,
    questions: PropTypes.array
}

PrintEducationBlock.propTypes = {
    education: PropTypes.array, 
    editAction: PropTypes.func,
    field: PropTypes.string,
    title: PropTypes.string,
    questions: PropTypes.array
}

PrintTags.propTypes = {
    tagsList: PropTypes.array, 
}

PrintListItems.propTypes = {
    listItems: PropTypes.array, 
}

PrintRefereesBlock.propTypes = {
    referees: PropTypes.array, 
    editAction: PropTypes.func,
    field: PropTypes.string,
    title: PropTypes.string,
    questions: PropTypes.array
}

PrintPortfolioBlock.propTypes = {
    portfolio: PropTypes.array, 
    editAction: PropTypes.func,
    field: PropTypes.string,
    title: PropTypes.string,
    questions: PropTypes.array
}